import cx from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Resizable } from 're-resizable';
import React from 'react';
import styles from '../layout.module.scss';
const SIDE_PANEL_COLLAPSED_WIDTH_PX = 0;
export const RightSideBar = ({ isRightPanelFloating, isRightPanelExpanded, rightPanelMaxWidth = 500, rightPanelMinWidth = 180, onResizeStop, isRightPanelResizable = false, children, className, }) => {
    const rightPanelFloadingMinWidth = SIDE_PANEL_COLLAPSED_WIDTH_PX;
    const rightPanelFloadingMaxWidth = SIDE_PANEL_COLLAPSED_WIDTH_PX;
    return (React.createElement(Resizable, { onResizeStop: onResizeStop, as: "section", className: cx(styles.sidePanel, styles.rightPanel, {
            [styles.floating]: isRightPanelFloating,
            [styles.expanded]: isRightPanelExpanded,
        }), minWidth: isRightPanelExpanded
            ? rightPanelMinWidth
            : rightPanelFloadingMinWidth, maxWidth: isRightPanelExpanded
            ? rightPanelMaxWidth
            : rightPanelFloadingMaxWidth, defaultSize: { width: '300px', height: 'auto' }, enable: {
            top: false,
            right: false,
            bottom: false,
            left: isRightPanelExpanded && isRightPanelResizable,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false,
        }, handleComponent: {
            left: React.createElement("div", null),
        }, handleClasses: {
            left: styles.resizeHandle,
        } },
        React.createElement(OverlayScrollbarsComponent, { options: {
                scrollbars: { autoHide: 'move' },
            }, className: styles.sidebarOverlayScroll },
            React.createElement("div", { className: cx(styles.innerContainer, className) }, children))));
};
//# sourceMappingURL=right-sidebar.js.map